export default __webpack_public_path__ + "static/media/2.a8a6e613.svg";